import { merge, cloneDeep } from 'lodash';
import { normalize } from 'normalizr';

import { jobs as jobsSchema } from './schema';

export const JOB_POSITIONS_AND_WEPLOYEES_FETCH_SUCCESS = 'JOB_POSITIONS_AND_WEPLOYEES_FETCH_SUCCESS';
export const JOB_DETAILS_FETCH_SUCCESS = 'JOB_DETAILS_FETCH_SUCCESS';

export const initialState = {
  positions: {},
  weployees: {},
  timesheets: {},
  jobs: {},
};

export const reducer = (state, action) => {
  switch (action.type) {
    case JOB_DETAILS_FETCH_SUCCESS: {
      const { weployer } = action.payload;
      const nomalisedData = normalize(weployer.job, jobsSchema).entities;
      const newState = cloneDeep(state);

      merge(newState, nomalisedData);
      return newState;
    }
    case JOB_POSITIONS_AND_WEPLOYEES_FETCH_SUCCESS: {
      const { weployer } = action.payload;
      const nomalisedData = normalize(weployer.job, jobsSchema).entities;
      const newState = cloneDeep(state);

      merge(newState, nomalisedData);
      return newState;
    }
    default:
      throw new Error('Invalid Action Type');
  }
};
